/*
 * @Author: your name
 * @Date: 2021-09-13 14:50:28
 * @LastEditTime: 2022-04-06 17:05:00
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \鲁南项目\src\modules\reserveImplement\options\alarmDetail.js
 */
import i18n from '@src/common/lib/i18n'
const columnAll = function () {
  return [{
      label: i18n.t('reserveImplement.label.alarmType'),
      prop: 'commonAlarmTypeLabel',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.alarmTime'),
      prop: 'alarmTime',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('reserveImplement.label.position'),
      prop: 'buildingName',
      formslot: true,
      span: 24
    }
  ]
}
const columnHelp = function () {
  return [{
      label: '告警名称',
      prop: 'alarmName',
      formslot: true,
      span: 24
    },
    {
      label: '告警类型',
      prop: 'alarmTypeLabel',
      formslot: true,
      span: 24
    },
    {
      label: "故障类型",
      prop: 'alarmSubType',
      formslot: true,
      span: 24
    },
    {
      label: '告警级别',
      prop: 'alarmLevel',
      formslot: true,
      span: 24
    },
    {
      label: '告警时间',
      prop: 'alarmTime',
      formslot: true,
      span: 24
    },
    {
      label: '所属设备组',
      prop: 'deviceWorkGroupName',
      formslot: true,
      span: 24
    },
    {
      label: '告警描述',
      prop: 'desc',
      formslot: true,
      span: 24
    },
    {
      label: "告警设备",
      prop: 'deviceName',
      formslot: true,
      span: 24
    },
    {
      label: "设备位置",
      prop: 'groupName',
      formslot: true,
      span: 24
    },
  ]
}

const columnFireWorks = function () {
  return [{
      label: '告警名称',
      prop: 'alarmName',
      formslot: true,
      span: 24
    },
    {
      label: '告警类型',
      prop: 'alarmTypeLabel',
      formslot: true,
      span: 24
    },
    {
      label: '告警级别',
      prop: 'alarmLevel',
      formslot: true,
      span: 24
    },
    {
      label: '告警时间',
      prop: 'alarmTime',
      formslot: true,
      span: 24
    },
    {
      label: '所属设备组',
      prop: 'deviceWorkGroupName',
      formslot: true,
      span: 24
    },
    {
      label: '告警描述',
      prop: 'desc',
      formslot: true,
      span: 24
    },
    {
      label: "告警设备",
      prop: 'deviceName',
      formslot: true,
      span: 24
    },
    {
      label: "设备位置",
      prop: 'groupName',
      formslot: true,
      span: 24
    },
  ]
}
export default {
  columnAll,
  columnHelp,
  columnFireWorks
}